import { conditionFilter } from "@@/shared/discounts/conditions/discount-condition-filter";
import type { OrderItem } from "@@/shared/orders/order-items/order-item";
import type { Percentage } from "@@/shared/percentage";
import { percentageOfPrice } from "@@/shared/prices/percentage-of-price";
import { zeroPrice } from "@@/shared/prices/price";
import { sumPrices } from "@@/shared/prices/sum-prices";
import type { DiscountCalculator } from "../discount-calculator-type";
import type { PercentageDiscount } from "./percentage-discount";

const percentageDiscountCalculator: DiscountCalculator<PercentageDiscount> =
    (discount: PercentageDiscount) => (items: OrderItem[]) => {
        const entitledItems = conditionFilter(discount, items);
        if (!entitledItems.length) return zeroPrice;

        // TODO! MAKE SURE IT'S A VALID TIME RANGE

        // Calculate discounted price
        const discountPrice = percentageOfPrice(
            sumPrices(entitledItems.map(item => item.price)),
            (1 - discount.value) as Percentage,
        );

        return discountPrice;
    };

const percentageDiscountCalculatorOrderItem =
    (discount: PercentageDiscount) => (item: OrderItem) => {
        const entitledItems = conditionFilter(discount, [item]);
        if (entitledItems.length !== 1) return zeroPrice;

        // TODO! MAKE SURE IT'S A VALID TIME RANGE

        // Calculate discounted price
        const discountPrice = percentageOfPrice(
            item.price,
            (1 - discount.value) as Percentage,
        );

        return discountPrice;
    };

export { percentageDiscountCalculator, percentageDiscountCalculatorOrderItem };
